import { IconClose } from "@icons/index";
import { IconTiktok } from "@icons/dark";
import { TestId } from "@shared/testIds";
import { Trans } from "react-i18next";

export interface ModalHeaderProps {
  onClose?: () => void;
  disabledClose?: boolean;
}

export const ModalHeader = ({ onClose, disabledClose }: ModalHeaderProps) => {
  return (
    <div className="flex h-[52px] items-center gap-[8px] px-[16px]">
      <span className="flex size-[24px] shrink-0 items-center justify-center rounded-[6px] bg-black">
        <IconTiktok width={16} height={16} />
      </span>
      <span className="flex-1 text-[15px] font-semibold leading-[22px] text-kds-fg">
        <Trans>Post to TikTok</Trans>
      </span>
      <button
        type="button"
        data-testid={TestId.PostToTikTokModalClose}
        onClick={onClose}
        disabled={disabledClose}
        className="flex size-[28px] shrink-0 cursor-pointer items-center justify-center rounded-[6px] border-0 bg-transparent text-kds-fg-soft hover:bg-kds-bg-overlay disabled:cursor-not-allowed disabled:opacity-50"
      >
        <IconClose className="size-[20px]" />
      </button>
    </div>
  );
};
